const TASTE_COLLECTION_TERRITORIES: readonly string[] = [
    'AR',
    'AU',
    'BR',
    'CA',
    'CL',
    'CO',
    'DE',
    'ES',
    'FR',
    'GB',
    'IN',
    'IT',
    'JP',
    'MX',
    'US',
]

/** GH's `isTerritorySupportedForATC`: taste collection has an artist category list there. */
export function tasteCollectionTerritory(territory: string): boolean {
    return TASTE_COLLECTION_TERRITORIES.includes(territory)
}
